import { render, staticRenderFns } from "./PFLoanFormNewManual.vue?vue&type=template&id=2c65cfba"
import script from "./PFLoanFormNewManual.vue?vue&type=script&lang=js"
export * from "./PFLoanFormNewManual.vue?vue&type=script&lang=js"
import style0 from "./PFLoanFormNewManual.vue?vue&type=style&index=0&id=2c65cfba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports